const appointmentPopup = () => {
    const popupWrapper = document.getElementById('popup-wrapper');
    const popupClose   = document.getElementById('popup-close');
    const body         = document.body;
    const scheduleBtn  = document.querySelector('.sidebar-block .secondary-btn.offline-button');

    if (!scheduleBtn) return;

    if (scheduleBtn) {
        scheduleBtn.addEventListener('click', (e) => {
            e.preventDefault();
            popupWrapper.style.display = 'flex';
            body.style.overflow = 'hidden';
            popupWrapper.classList.add('active');
        });
    }

    if (popupClose) {
        popupClose.addEventListener('click', () => {
            popupWrapper.style.display = 'none';
            body.style.overflow = 'auto';
            popupWrapper.classList.remove('active');
        });
    }
};

export default appointmentPopup;

